import tablets from './tablets';
import inspector from './inspector';
import settings from './settings/settings';
import settingsSidebar from './settings/sidebar';
import settingsResearch from './settings/research';
import { columnsTooltipProps } from './columnsTooltipProps';

export { tablets, inspector, settings, settingsSidebar, settingsResearch, columnsTooltipProps };
